var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 4.99996L5.90013 13.0997M13.9998 4.99996L1.65408 9.33961C1.196 9.5007 1.0637 10.083 1.39804 10.3975C1.42053 10.4176 1.44513 10.4353 1.47139 10.4502L5.90013 13.0997M13.9998 4.99996L9.6602 17.3457C9.50136 17.7989 8.92988 17.933 8.61309 17.6126C8.58553 17.5832 8.56235 17.55 8.54424 17.514L5.90013 13.0997",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendicon);
export default __webpack_public_path__ + "static/media/sendicon.637b5d298510dba1990b0776603788f4.svg";
export { ForwardRef as ReactComponent };